export const getCanonicalArgsFromPathname = props => {
  let url = props.location?.pathname;
  const isSportsBook = url?.split('/')[1]?.includes('iddaa');
  const isDefaultUrl = url?.split('/')[1]?.includes('canli-iddaa');
  const canonicalCheck = url?.includes('iddaa/kupon') || url?.includes('tjk/at-yarisi-sonuclari') || url?.includes('tjk/at-karti') || url?.includes('tribun/arama') || url?.includes('tribun/profil');
  const canonicalCheckAuthors = url?.includes('/yazarlar');
  const canonicalCheckMatchCard = url?.includes('/mac-karti');
  // const noAlternateList = ['esya-piyangosu', 'canli-voleybol-izle', 'canli-tenis-izle', 'canli-hentbol-izle', 'canli-motor-sporlari-izle', 'canli-snooker-izle', 'canli-buz-hokeyi-izle', 'canli-masa-tenisi-izle', 'sans-oyunlari', 'yilin-enleri'];
  // const isMobileWebUrl = noAlternateList.some(e=> url.includes(e));

  if (isSportsBook) {
    url = url?.replace(/^\/iddaa\/futbol/, '/iddaa');
  }

  if (isDefaultUrl) {
    url = url?.replace(/^\/canli-iddaa\/futbol/, '/canli-iddaa');
  }

  if (canonicalCheck) {
    return {
      href: `https://www.bilyoner.com${url}`.replace(/\/*$/, '')
    };
  } else if (canonicalCheckAuthors) {
    if (url.includes('/futbol')) {
      return {
        rel: 'canonical',
        href: 'https://www.bilyoner.com/yazarlar'.replace(/\/*$/, '')
      };
    }
    return {
      rel: 'canonical',
      href: `https://www.bilyoner.com${url}`.replace(/\/*$/, '')
    };
  } else if (canonicalCheckMatchCard) {
    return {
      rel: 'canonical',
      href: 'https://www.bilyoner.com/iddaa'.replace(/\/*$/, '')
    };
  } else {
    let searchParam = '';

    if (props?.location?.pathname.includes('/esya-piyangosu/detay/')) {
      searchParam = props?.location?.search;
    }
    return {
      rel: 'canonical',
      href: `https://www.bilyoner.com${url}${searchParam}`.replace(/\/*$/, '')
    };
  }
};
